<template>
  <common
    :searchFrom="searchFrom"
    :tableTitle="tableTitle"
    :list="list"
    @crudClick="crudClick"
    :total="total"
    :arrPageSize="arrPageSize"
    :pageSize="searchFrom.pageSize"
    :BoolModal="isshowModal"
    :title="titleModal"
    @changeBindModal="changeBindModal"
    @closedeleteModal="closedeleteModal"
    :unChange="unChange"
    :footerHide="footerHide"
    :width="width"
    :loading="loading"
    :maskClosable="maskClosable"
    :current.sync="current"
    @pageClick="getList"
    ref="common"
  >
    <template slot="add">
      <FormItem>
        <Button type="primary" @click="crudClick(0, 'add')" icon="md-add">
          {{ $t("add") }}
        </Button>
      </FormItem>
    </template>

    <div slot="content">
      <template v-if="crudText == 'delete'">
        <p>{{ $t("titleModal") }}</p>
      </template>
      <template v-else>
        <Form
          label-position="right"
          :model="dataDetails"
          :label-width="130"
          :rules="ruleFrom"
          ref="dataDetails"
        >
          <template v-if="crudText != 'update'">
            <FormItem :label="$t('roleName')" prop="role_id">
              <Select
                v-model="dataDetails.role_id"
                filterable
                :disabled="disabled"
                placeholder="Please Select Role"
              >
                <Option
                  v-for="item in objRole"
                  :value="item.id"
                  :key="item.id"
                  >{{ item.role_name }}</Option
                >
              </Select>
            </FormItem>
          </template>
          <FormItem :label="$t('standard_role')" prop="standard_role">
            <Select
              v-model="dataDetails.standard_role"
              filterable
              :disabled="disabled"
              placeholder="Please Select StandardRole"
            >
              <Option v-for="item in standardList" :value="item" :key="item">{{
                item
              }}</Option>
            </Select>
          </FormItem>
        </Form>
      </template>
    </div>
  </common>
</template>

<script>
import {
  getRoleMapping,
  add,
  del,
  update,
  getDetails,
} from "@/api/system/role_map";
import common from "_c/common-body";
import basic from "@/utils/basic";
import nodata from "@/utils/nodata";
import boxMes from "@/utils/message";

export default {
  name: "role_map",
  components: {
    common,
  },
  data() {
    return {
      current: 1,
      objRole: {},
      arrPageSize: [15, 20, 30, 40],
      maskClosable: false,
      loading: true,
      width: 600,
      list: [],
      searchFrom: {
        page: 1,
        pageSize: 15,
        keywords: "",
      },
      // Warehouse总数据
      total: 0,
      // 详情模态框显示/隐藏
      isshowModal: false,
      // 数据详情
      dataDetails: {},
      // 删除模态显示/隐藏
      Delmodal1: false,
      // 模态框标题
      isshowModalTitle: "",
      disabled: false,
      ruleFrom: {
        role_id: [
          {
            required: true,
            type: "number",
            message: "role_name cannot be empty",
            trigger: "change",
          },
        ],
        standard_role: [
          {
            required: true,
            message: "standard_role cannot be empty",
            trigger: "blur",
          },
        ],
      },
      footerHide: false,
      crudText: "",
      titleModal: "",
      deleteModal: false,
      delId: 0,
      preForm: {},
      unChange: true,
      standardList: [
        "WarehouseStaff",
        "CustomerService",
        "FinanceService",
        "WarehouseManager",
        "Driver",
        "Salesmen",
        "Agent",
      ],
    };
  },
  computed: {
    tableTitle() {
      let columns = [];
      columns.push({
        title: this.$t("roleName"),
        key: "role_name",
        align: "center",
        minWidth: 100,
      });
      columns.push({
        title: this.$t("standard_role"),
        key: "standard_role",
        align: "center",
        minWidth: 150,
      });
      columns.push({
        title: this.$t("operation"),
        slot: "operation",
        align: "center",
        minWidth: 280,
      });
      return columns;
    },
  },
  watch: {
    dataDetails: {
      handler: function (nowVal) {
        var $this = this;
        for (let i in $this.dataDetails) {
          if (nowVal[i] !== $this.preForm[i]) {
            $this.unChange = false;
            break;
          } else {
            $this.unChange = true;
          }
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.getList(this.searchFrom);
  },
  methods: {
    changeBindModal(val) {
      if (!val) {
        this.isshowModal = false;
      } else {
        if (this.crudText === "delete") {
          console.log(this.delId);
          this.deleteList(this.delId);
        } else {
          this.confirm("dataDetails");
        }
      }
    },
    closedeleteModal(e) {
      if (e === false) {
        this.isshowModal = false;
        if (this.crudText != "delete") {
          this.$refs["dataDetails"].resetFields();
        }
      }
    },
    confirm(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          if (this.crudText === "add") {
            this.addList();
          } else {
            this.updateList();
          }
        } else {
          console.log(this.$t("fail"));
        }
      });
    },
    crudClick(item, text) {
      this.objRole = basic.objDictRole();

      this.titleModal = this.$t(text);
      this.maskClosable = false;
      this.width = 600;
      this.footerHide = false;
      this.unChange = true;
      this.disabled = false;
      this.dataDetails = {};
      this.preForm = {};
      if (item !== 0) {
        if (text == "delete") {
          this.width = 300;
          this.delId = item.role_id;
          this.unChange = false;
          this.maskClosable = true;
        } else {
          if (text === "show") {
            this.disabled = true;
            this.footerHide = true;
            this.maskClosable = true;
          }
          this.getDetailsList(item.role_id, text);
        }
      }
      this.isshowModal = true;
      this.crudText = text;
    },
    getDetailsList(id) {
      getDetails(id)
        .then((res) => {
          delete res.data.payload.country;
          this.dataDetails = res.data.payload;
          this.preForm = JSON.parse(JSON.stringify(res.data.payload));
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getList() {
      this.loading = true;
      getRoleMapping(this.searchFrom)
        .then((res) => {if (!res.data.status) {
            this.loading = false;
            boxMes.alertMes(res, this);
            return;
          }
          // this.list = res.data.payload.rows
          this.total = res.data.payload.total;
          this.list = res.data.payload.rows.map((item) => {
            let role = nodata.noData(basic.objDictRole(), item.role_id, "role");
            item.role_name = role.name;
            return item;
          });
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    addList() {
      add(this.dataDetails).then((res) => {
        boxMes.alertMes(res, this);
      });
    },
    updateList() {
      delete this.dataDetails.country;
      update(this.dataDetails).then((res) => {
        boxMes.alertMes(res, this);
      });
    },
    deleteList(id) {
      del(id).then((res) => {
        boxMes.alertMes(res, this);
      });
    },
  },
};
</script>

<style scoped lang="less">
.delBtn {
  margin: 0 10px;
}
.ivu-page {
  margin-top: 20px;
}
.footer-modal {
  width: 100%;
  text-align: center;
}
</style>
